import * as React from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput {...other}
      mask="(00) 00-00-00-00"
      definitions={{ '#': /[0-9]/, }}
      inputRef={ref}
      onAccept={() => { }}
      onChange={props.onChange}
      style={{ width: 500 }}
      fullWidth={true}
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

TextMaskCustom.defaultProps = {
  name: "Custom",
  onChange: () => { }
}

const TextMask = (props) => {
  return (
    <FormControl variant="standard">
      <InputLabel htmlFor="standard-adornment-amount">{props.label}</InputLabel>
      <Input value={props.value} onChange={props.onChange} fullWidth={true} variant="standard" onRowDataChange={props.onRowDataChange} name={props.name} id={props.id} inputComponent={TextMaskCustom} />
    </FormControl>
  );
}

export default React.memo(TextMask);
